module.exports = __webpack_public_path__ + "img/GooglePay.59195700.svg";